import React, { useEffect, useState } from 'react';
import { host_url } from '../../App';
import '../ListenSubpage.css';
import '../../styles/CiTable.css';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';

function Sparkasse() {
  const [einheiten, setEinheiten] = useState([]);
  const [selectedEinheit, setSelectedEinheit] = useState('');
  const [sortBy, setSortBy] = useState('Name');
  const [daten, setDaten] = useState([]);

  useEffect(() => {
    fetch(`${host_url}/einheiten`)
      .then(res => res.json())
      .then(data => setEinheiten(data))
      .catch(err => console.error('Error fetching einheiten:', err));
  }, []);

  const sortData = (data) => {
    const sorted = data.slice();
    switch (sortBy) {
      case 'Zelt':
        sorted.sort((a, b) => a.ZeltName.localeCompare(b.ZeltName));
        break;
      case 'Job':
        sorted.sort((a, b) => a.JobName.localeCompare(b.JobName));
        break;
      case 'Name':
      default:
        sorted.sort((a, b) => a.KindName.localeCompare(b.KindName));
    }
    return sorted;
  };

  useEffect(() => {
    const url = selectedEinheit
      ? `${host_url}/zuteilungen?einheitId=${selectedEinheit}`
      : `${host_url}/zuteilungen`;
    fetch(url)
      .then(res => res.json())
      .then(data => setDaten(sortData(data)))
      .catch(err => console.error('Error fetching zuteilungen:', err));
  }, [selectedEinheit, sortBy]);

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/listen" />
      <h1 className="section-title blue">Sparkasse</h1>
      <form className="no-print">
        <label htmlFor="einheit">Einheit</label>
        <div className={`dropdown-wrapper ${selectedEinheit ? 'filled' : ''}`}>
          <select name="einheit" id="einheit" value={selectedEinheit} onChange={e => setSelectedEinheit(e.target.value)}>
            <option value="">Alle Einheiten</option>
            {einheiten.map(einheit => (
              <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>
            ))}
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
        <label htmlFor="sortierung">Sortieren nach</label>
        <div className={`dropdown-wrapper ${sortBy ? 'filled' : ''}`}>
          <select name="sortierung" id="sortierung" value={sortBy} onChange={e => setSortBy(e.target.value)}>
            <option value="Name">Name</option>
            <option value="Zelt">Zelt</option>
            <option value="Job">Job</option>
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
      </form>
      {daten.length > 0 ? (
        <>
          <div className="table-header">
            <span className="print-link no-print" onClick={() => window.print()}>
              <span className="material-symbols-outlined">print</span>
              <span className="print-text">Drucken</span>
            </span>
          </div>
          <div className="ci-table-wrapper">
            <table className="ci-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Zelt</th>
                  <th>Job</th>
                </tr>
              </thead>
              <tbody>
                {daten.map((row, index) => (
                  <tr key={index} className="tent-row">
                    <td>{row.KindName}</td>
                    <td>{row.ZeltName}</td>
                    <td>{row.JobName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <p>Keine Daten gefunden.</p>
      )}
    </div>
    </KernteamLayout>
  );
}

export default Sparkasse;